<script>
    import Svg from "vpap/svelte/Svg.svelte";

    export let width, percent;

    const barHeight = 25;
    const threshold = 70;

    $: offset = percent > threshold ? -5 : 5;

    let showInfo = false;
    let hovered = false;
</script>

<template>
    <div class="progress-label">
        <div class="label-text">
            Weighted Votes Tallied
        </div>
        <button 
            aria-label="Expandable info button. Click to learn more about what weighted votes are."
            class:expand-color={hovered} 
            type="button" 
            on:click={() => showInfo = !showInfo}
            on:focus={() => hovered = true}
            on:mouseover={() => hovered = true}
            on:blur={() => hovered = false}
            on:mouseleave={() => hovered = false}
        >
            <!-- From bootstrap icons -->
            <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
              </svg>
        </button>
    </div>
    {#if showInfo}
    <div class="votes-info">
        Winners are decided by a system that weights votes by GOP unit. Each unit has a fixed number of delegate votes. The formula to determine each candidate's weighted vote in each unit is: (Number of Ballots Received/Total Ballots Cast) x Number of Assigned Delegate Votes
    </div>
    {/if}
    <Svg
        width={width}
        height={barHeight}
        description={`A progress bar showing that ${percent} percent of the weighted vote has been tallied`}
        titleId="results-progress-image"
        >
        <rect class="empty" width={width} height={barHeight}></rect>
        <rect class="filled" width={width * (percent / 100)} height={barHeight}></rect>
        <text 
            class:inside={percent > threshold}
            x={width * (percent / 100) + offset}
            y={barHeight/2 + 6}
        >{percent}%</text>
    </Svg>
</template>

<style lang="scss">
    rect.empty {
        fill: #e6e9eb;
    }

    rect.filled {
        fill: #596e7c;
    }

    text {
        font-weight: bold;
        fill: #596e7c;

        &.inside {
            text-anchor: end;
            fill: white;
        }
    }

    .progress-label {
        display: flex;
        align-items: center;
    }

    .votes-info {
        padding-left: 2ch;
        font-size: .9em;
        margin-bottom: .7em;
    }

    button {
        border: none;
        cursor: pointer;
        background-color: inherit;

        &:hover, &:focus {
            outline: none;
        }

        &.expand-color {
            & svg {
                fill: $vpap-blue;
                transform: scale(1.1);
            }
        }
    }
</style>